import React from 'react';
import { Row, Col } from 'antd';

import './Footer.scss';
import { LogoMinistri, LogoGroup } from '../../assets/index';

const listInfo = [
  {
    id: 0,
    info: 'Tổng đài chăm sóc: 1900 2083',
  },
  {
    id: 1,
    info: 'Email: hotro@mytour.vn',
  },
  {
    id: 2,
    info: 'Văn phòng Hà Nội: Tầng 11, Tòa Peakview, 36 Hoàng Cầu, Đống Đa',
  },
  {
    id: 3,
    info: 'Văn phòng HCM: Tầng 6, Tòa Nhà Central Park, 117 Nguyễn Du, Q.1',
  },
  {
    id: 4,
    info: 'Mytour Store: 168 Xã Đàn, Đống Đa, Hà Nội',
  },
];
const listPolicy = [
  {
    id: 0,
    policy: 'Điều kiện & Điều khoản',
    src: 'https://doitac.mytour.vn/help/list?tab=dieu-kien-dieu-khoan',
  },
];

const listPartner = [
  {
    id: 0,
    partner: 'Đăng nhập HMS',
    src: 'https://hms.mytour.vn/login?from=%2F',
  },
  {
    id: 1,
    partner: 'Tuyển dụng',
    src: 'https://career.mytour.vn/',
  },
  {
    id: 2,
    partner: 'Liên hệ',
    src: 'https://mytour.vn/help/30-lien-he.html',
  },
];

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-content'>
        <Row>
          <Col span={9}>
            <div className='logo_footer'>
              <img
                src='https://storage.googleapis.com/tripi-assets/mytour/icons/icon_logo_mytour_red.svg'
                alt='img_logo'
              />
            </div>
            <div className='company_name'>
              Công ty cổ phần du lịch Việt Nam VNTravel
            </div>
            <div className='info_company'>
              {listInfo.map((el, index) => (
                <div className='wrap_info' key={index}>
                  <span className='info'>{el.info}</span>
                </div>
              ))}
            </div>
          </Col>

          <Col span={8}>
            <div className='logo_footer' />
            <div className='company_name'>Chính sách & Quy định</div>
            {listPolicy.map((el, index) => (
              <div className='wrap_policy' key={index}>
                <a href={el.src} className='policy'>
                  {el.policy}
                </a>
              </div>
            ))}
          </Col>
          <Col span={7}>
            <div className='logo_footer' />
            <div className='wrap_ministri'>
              <LogoMinistri />
            </div>
            {/* <div className='company_name'>Khách hàng và đối tác</div>
            {listPartner.map((el, index) => (
              <div className='wrap_partner' key={index}>
                <a href={el.src} className='partner'>
                  {el.partner}
                </a>
              </div>
            ))} */}
            {/* <div className="company_name">Kết nối với Mytour</div>
            <div className="logo_contact">
              <LogoFacebook />
              <div className="logo_messenger">
                <LogoMessenger />
              </div>
              <LogoInstagram />
            </div> */}
          </Col>
          <div className='divider' />
        </Row>
        <Row>
          <Col span={24}>
            <div className='company_desc'>
              <span className='desc'>
                Mytour là thành viên của VNTravel Group - Một trong những tập
                đoàn đứng đầu Đông Nam Á về du lịch trực tuyến và các dịch vụ
                liên quan.
              </span>
            </div>
            <div className='logo_group'>
              <LogoGroup />
            </div>
            <div className='company_copy_right'>
              <span className='copy_right'>
                Copyright © 2020 - CÔNG TY CỔ PHẦN DU LỊCH VIỆT NAM VNTRAVEL -
                Đăng ký kinh doanh số 0108886908 - do Sở Kế hoạch và Đầu tư
                thành phố Hà Nội cấp lần đầu ngày 04 tháng 09 năm 2019
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Footer;
